export const FORM_NAME = 'SPAM_PREVENTION_SIDEBAR_FORM';
